import { combineReducers } from 'redux';
import {machineDataReducer} from "./machineDataReducer";
import {userDetailsReducer} from "./userDetailsReducer";
import { machineActiveDataReducer } from './activeDataReducer';

export const reducer = combineReducers({
    machineDataReducer,
    userDetailsReducer,
    machineActiveDataReducer
});